(function ($) {
  'use strict';

  var dimImageContentBlock = function () {

    var blocks = $('.content-block--inverse.content-block--bg-image');

    blocks.each(function () {
      var parent = $(this).closest('.split-col__item');
      parent.addClass('dimmer');
    });
  };

  dimImageContentBlock();

}(jQuery));